<template>
  <span>
    <!-- this button can be hidden to allow inline multiple processing -->
    <large-button v-if="usedefaultbutton" class="w3-medium" @click="openDialog()"><slot name="buttonicon"></slot>{{buttontext}}</large-button> 

    <dialog-layout ref="confirmDialog" :id="id" @click="dialogActions" :type="type">        

        <h3 slot="headercontent">{{buttontext}}?</h3>

        <span>
          <p>
            <slot></slot>
          </p>  
          <slot name="controls" :meta="meta" v-if="meta"></slot>
          <cancel-dialog-button @click="yesno(false)">No</cancel-dialog-button>
          
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;                        
          <large-button @click="yesno(true)" :class="[type==='warning'?'w3-red' : 'w3-green']">{{oktext}}</large-button>                                  
        </span>

    </dialog-layout>
  </span>
</template>


<script>
export default {
  props: {
    id: {
      type: String,      
      default:'ConfirmDialogModal'
    },
    buttontext: {
      type: String,
      default:"Yes/No"      
    },
    oktext: {
      type: String,
      default:"Yes"
    },
    usedefaultbutton: {
      type: Boolean,
      default:false
    },
    type: {
      type: String,
      default:'warning'
    }
  },  
  data: function() {
      return {        
        meta:null
      }
  },
  methods: {
    dialogActions(e){
        if(e.action==="canceldialog")
        {          
        }        
    },
    openDialog(meta){
      if(meta)
      {
        this.meta = meta//pass through the meta
      }

      this.$refs.confirmDialog.show() 
    },
    cancelDialog() {      
      this.$refs.confirmDialog.cancelDialog() 
    },    
    yesno(yes) {
      this.$emit("click", {action:yes,data:this.meta});
      this.cancelDialog();
    }
  }
};
</script>
 
<style>
.dialogcontent {
  padding-top: 10px;
  padding-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/controls/ConfirmDialog.vue